module.exports = __webpack_public_path__ + "static/media/platform-illustration.b2cfb556.svg";